var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsightsIconOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_1481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.40243 3.4756C10.0854 3.81707 10.6829 4.32926 11.1097 5.01219C11.7927 6.12194 11.7927 7.4878 11.0244 8.25609L11.7927 9.62194L18.4512 6.03658C16.6585 3.81706 14.3536 2.02438 12.0488 0.914626C9.74389 -0.109765 7.60974 -0.451228 5.98779 0.146333L7.78048 3.04877C8.29267 2.96341 8.89023 3.2195 9.40243 3.4756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70728 14.9146C4.87801 15.1707 5.04874 15.5122 5.30484 15.8537C7.01215 18.5854 9.31703 20.4634 11.6219 21.3171C14.0122 22.2561 16.317 22.1707 18.3658 21.1463C20.3292 20.0366 21.5243 18.2439 21.8658 15.8537C22.2073 13.5488 21.6097 10.7317 19.9024 8C19.7317 7.65854 19.4756 7.40244 19.3048 7.06097L4.70728 14.9146ZM18.0243 18.4146C17.7682 18.5 17.5975 18.5 17.4268 18.2439C17.3414 18.0732 17.4268 17.9024 17.5975 17.7317C20.0731 16.3659 20.7561 12.8659 18.878 9.87805L18.7926 9.70732C18.7073 9.53658 18.7073 9.36585 18.9634 9.19512C19.1341 9.10976 19.3902 9.19512 19.4756 9.36585L19.5609 9.53658C21.6097 12.7805 21.0122 16.7073 18.0243 18.4146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84144 7.31706C6.41461 6.63413 6.15852 5.86584 6.15852 5.18291C6.15852 4.67072 6.32925 4.07316 6.58534 3.73169L4.79266 0.829254C3.42681 1.85364 2.65852 3.73169 2.57315 6.03657C2.40242 8.42682 2.91461 11.1585 4.10974 13.7195L10.6829 10.2195L9.82925 8.85364C8.71949 9.02438 7.52437 8.42682 6.84144 7.31706Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_1481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsIconOn);
export default __webpack_public_path__ + "static/media/InsightsIconOn.6a16d8033fd39e925e817656568f5c96.svg";
export { ForwardRef as ReactComponent };